import type { ISort } from '@/ui/table/table.types';
import { atom } from 'jotai';

export enum TemplateSortKey {
  fileType = 'fileType',
  createdDate = 'createdDate',
}

export const templatesSortState = atom<ISort<TemplateSortKey>>({
  sort: TemplateSortKey.createdDate,
  direction: 'desc',
});
